module.exports = __webpack_public_path__ + "static/media/predestinado_o.79d1275d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/predestinado_o.png
// module id = 1167
// module chunks = 0